import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-vs-render',
  imports: [RouterLink, MatButtonModule, MatIconModule],
  templateUrl: './render.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../vs.shared.css', './render.component.css'],
})
export class VsRenderComponent {}
